// Typelizer digest b7ff528e9af3bebe9ea1bcb4d3358815
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/payments/:payment_id/counterparty_rule_draft */
  show: (
    params: { paymentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/payments/:payment_id/counterparty_rule_draft', params, options),
    method: 'get',
  }),
}
